import api from 'api';
import type {
  ImportStatus,
  IntegrationProjects,
  IntegrationWorkspaces,
} from 'redux/modules/integrations.types';

export const integrationsApi = {
  getWorkspaces(accountId: number): Promise<IntegrationWorkspaces> {
    return api.get(`apps/${accountId}/workspaces`);
  },
  getProjectsForWorkspace({
    accountId,
    workspaceId,
  }: {
    accountId: number;
    workspaceId: number | string;
  }): Promise<IntegrationProjects> {
    return api.get(`apps/${accountId}/workspaces/${workspaceId}/projects`);
  },
  startImport({
    accountId,
    workspaceId,
    projectIds,
  }: {
    accountId: number;
    workspaceId: number | string;
    projectIds: Array<number | string>;
  }): Promise<Array<ImportStatus>> {
    return api.post(`apps/${accountId}/jobs`, {
      job: {
        workspace_id: workspaceId,
        project_ids: projectIds,
      },
    });
  },
  getImportStatus(accountId: number): Promise<Array<ImportStatus>> {
    return api.get(`apps/${accountId}/jobs`);
  },
};
